import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ImageList.module.css";
import { encoded, encodeFileNameOnly } from "@/utils";
import { FrameType, CoupangAdBanner } from "@/components";

const ImageList = React.memo(function ({
  list = [{ id: "", image: "", title: "", description: "" }],
  defaultUrl = "",
  updateUrl = "",
  isUpdate = false,
  isDelete = false,
  isReset = false,
  setDeletes = () => {},
  resetDeletes = () => {},
}) {
  const adMessage =
    "이 포스팅은 쿠팡 파트너스 활동의 일환으로, 이에 따른 일정액의 수수료를 제공받습니다.";
  const defaultState = {
    onLoad: false,
  };
  const [state, setState] = useState({
    ...defaultState,
  });

  const resetState = () => {
    setState({ ...defaultState });
  };
  const addOnLoadClass = () => {
    setState((s) => ({ ...s, onLoad: true }));
  };
  const adKey = useMemo(() => new Date().getTime(), []);

  useEffect(() => {
    if (isReset) {
      resetState();
    }
    const callbackId = requestIdleCallback(addOnLoadClass);
    return () => {
      resetState();
      cancelIdleCallback(callbackId);
    };
  }, [isReset, isUpdate, list]);
  return (
    <div
      className={
        state.onLoad
          ? `${styles.categoryListAll} ${styles.loaded}`
          : styles.categoryListAll
      }
    >
      <div className={styles.categoryList}>
        {list.length === 1 && list[0].id === ""
          ? null
          : list.map((content, idx) => (
              <Content
                key={idx}
                id={content.id}
                image={content.image}
                title={content.title}
                description={content.description}
                defaultUrl={defaultUrl}
                updateUrl={updateUrl}
                isUpdate={isUpdate}
                isDelete={isDelete}
                isReset={isReset}
                time={new Date().getTime()}
                setDeletes={setDeletes}
                resetDeletes={resetDeletes}
              />
            ))}
        <div className={styles.adArea}>
          <div className={styles.adImage}>
            <CoupangAdBanner frameType={FrameType.SQUARE} />
          </div>
          <span className={styles.ad}>광고</span>
          <div className={styles.description}>
            <span className={styles.profitableAd}>{adMessage}</span>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ImageList;

const Content = React.memo(
  ({
    id = "",
    image = "",
    title = "",
    description = "",
    defaultUrl = "",
    updateUrl = "",
    isUpdate = false,
    isDelete = false,
    isReset = false,
    time = 1,
    setDeletes = () => {},
    resetDeletes = () => {},
  }) => {
    const navigate = useNavigate();
    const defaultState = {
      onOff: false,
    };
    const [state, setState] = useState({
      ...defaultState,
    });

    const resetState = () => {
      setState({ ...defaultState });
    };
    const click = () => {
      const encodedTitle = encoded(title);
      if (!isUpdate && !isDelete) {
        navigate(`${defaultUrl}/${id}/${encodedTitle}`);
        return;
      }
      if (isUpdate) {
        const randomTag = new Date().getTime();
        const info = encoded(
          {
            id: id,
            categoryNm: title,
            description: description,
            image: image,
          },
          true
        );
        navigate(`${updateUrl}/${randomTag}/${info}`);
        return;
      }
      if (isDelete) {
        setState((s) => ({ ...s, onOff: !s.onOff }));
        return;
      }
    };

    const imageStyle = {
      backgroundImage: `url(${encodeFileNameOnly(image)}?t=${time})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    };

    useEffect(() => {
      if (isReset) {
        resetState();
      }
      return () => {
        resetState();
      };
    }, [isReset]);
    useEffect(() => {
      if (isDelete && state.onOff) {
        setDeletes({ index: id });
      } else if (isDelete && !state.onOff) {
        resetDeletes({ index: id });
      }
    }, [isDelete, state.onOff]);
    return (
      <div className={styles.categoryArea} onClick={click}>
        <div className={styles.categoryImage} style={imageStyle}>
          {isDelete && state.onOff && (
            <div className={styles.listItemDisabled}>
              <div className={styles.checkIcon} />
            </div>
          )}
        </div>
        <div className={styles.titleDescriptionArea}>
          <div className={styles.title2}>
            <span className={styles.babyFood}>{title}</span>
          </div>
          <div className={styles.description}>
            <span className={styles.infantNutritionInfo}>{description}</span>
          </div>
        </div>
      </div>
    );
  }
);
